import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import { useCallback } from 'react';
import { Rubric } from '../../../../../schemas/Rubric.schema';
import { useDeleteRubric } from './rubricActions';

export function DeleteRubric({ rubric }: { rubric: Rubric }) {
  const deleteRubric = useDeleteRubric().mutateAsync;
  const onDelete = useCallback(async () => {
    await deleteRubric(rubric);
  }, [deleteRubric, rubric]);

  return (
    <IconButton onClick={onDelete} title='delete'>
      <ClearIcon />
    </IconButton>
  );
}
